import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularUsd: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_usd"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="usd icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 17 28"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.10429 24.5208C6.28143 24.3532 4.74668 23.8189 3.50001 22.9179C2.25334 22.017 1.35763 20.7703 0.812866 19.1779L3.13858 17.9836C3.36906 19.1151 3.94524 20.0736 4.86715 20.8594C5.78906 21.6451 6.8681 22.1532 8.10429 22.3836V15.0922C6.74238 14.7989 5.6162 14.4794 4.72572 14.1336C3.83524 13.7879 3.09668 13.2694 2.51001 12.5779C1.92334 11.8865 1.63001 10.9646 1.63001 9.81222C1.63001 8.76459 1.89191 7.81127 2.41572 6.95222C2.93954 6.09317 3.68858 5.38603 4.66287 4.83079C5.63716 4.27555 6.78429 3.94555 8.10429 3.84079V0.666504H10.2729V3.87222C11.8233 3.99793 13.1067 4.41174 14.1229 5.11365C15.1391 5.81555 16.0138 6.84745 16.7472 8.20936L14.7043 9.81222C14.1805 8.59697 13.5833 7.69603 12.9129 7.10936C12.2424 6.52269 11.3624 6.15603 10.2729 6.00936V13.3951C11.6348 13.6884 12.761 14.0079 13.6514 14.3536C14.5419 14.6994 15.2857 15.2284 15.8829 15.9408C16.48 16.6532 16.7786 17.6065 16.7786 18.8008C16.7786 20.4141 16.1919 21.7289 15.0186 22.7451C13.8452 23.7613 12.2634 24.3532 10.2729 24.5208V27.6951H8.10429V24.5208ZM10.2729 22.4465C13.0386 22.216 14.4214 21.0637 14.4214 18.9894C14.4214 18.0255 14.06 17.2922 13.3372 16.7894C12.6143 16.2865 11.5929 15.8779 10.2729 15.5636V22.4465ZM5.05573 7.10936C5.74716 6.48079 6.76334 6.10365 8.1043 5.97794V12.9551C6.78429 12.6408 5.77335 12.2427 5.07144 11.7608C4.36953 11.2789 4.01858 10.5665 4.01858 9.62365C4.01858 8.57603 4.3643 7.73794 5.05573 7.10936Z"
        />
      </svg>
    </span>
  );
};

export { RegularUsd };
